import React, { useEffect } from 'react';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import '../EditEmployee.css';
import { fetchProvinceTypesRequest } from '../../../redux/actions/provinceActions.js';



const EditSiteForm = ({
  site,
//   provinces = [], 
  onSubmit,
  closeModal,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { provinceTypes} = useSelector(state => state.provinceType  || {} );


  // Fetch data on mount
  useEffect(() => {
    dispatch(fetchProvinceTypesRequest());
  }, [dispatch]);






  // Prefill form data with site information
  useEffect(() => {
    if (site) {
      form.setFieldsValue({
        ...site,
        province: site.province?.id || site.province,
      });
    }
  }, [site, form]);

  // Handle form submission
  const handleFinish = (values) => {
    const updatedSite = {
      ...site, // Preserve existing data
      ...values, 
    };

    if (onSubmit) {
      onSubmit(updatedSite); // Send updated data to parent component
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="Corporation Number"
            name="corporationno"
            rules={[{  message: "Please enter the Corporation Number" }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Email" name="email">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>
        </Col>


     
      </Row>

      <Row gutter={16}>

        
      <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item
            label="Province"
            name="province"
            rules={[{  message: "Please select the province" }]}
          >

              <Select
                    size="large"
                    // onChange={handleProvinceChange}
                    placeholder="Select Province"
                    showSearch // Enables search  
                    optionFilterProp="children" // Searches in dropdown text
                    filterOption={(input, option) =>
                      (option?.children || '').toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {provinceTypes && provinceTypes.map((province) => (
                      <Select.Option key={province.id} value={province.province}>
                        {province.province}
                      </Select.Option>
                    ))}
                  </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Phone" name="phone">
            <Input />
          </Form.Item>
        </Col>

      
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Postal Code" name="postalcode">
            <Input />
          </Form.Item>
        </Col>
    
      </Row>

      <Row gutter={16}>

      <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="City" name="city">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <Form.Item label="Website" name="website">
            <Input />
          </Form.Item>
        </Col>

      </Row>

      {/* Buttons */}
      <div  style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}>
        <Button type="primary" htmlType="submit" style={{ marginRight: "10px" }}>
          Save
        </Button>
      </div>
    </Form>
  );
};

export default EditSiteForm;
